import {
    EpiContext,
    UpdateEpiContextActionTypes,
    UPDATE_LANGUAGE,
    UPDATE_VALUTA,
    UPDATE_EPIMODEL,
    UPDATE_CONTEXT,
    UPDATE_ZINDEX,
} from './Types';

export function epiContextReducer<T>(
    state: EpiContext<T> = {
        epiModel: null,
        epiModelTimestamp: 0,
        epiModelFeilet: false,
        locale: 'nb-no',
        valuta: 'kr',
        epiEditContext: {
            inEditMode: false,
            isEditable: false,
            editZIndex: 1,
        },
    },
    action: UpdateEpiContextActionTypes<T>,
): EpiContext<T> {
    switch (action.type) {
        case UPDATE_EPIMODEL: {
            if (state.epiModelTimestamp < action.payload.epiModelTimestamp) {
                return {
                    ...state,
                    ...action.payload,
                };
            } else {
                return state;
            }
        }
        case UPDATE_LANGUAGE: {
            return {
                ...state,
                locale: action.payload,
            };
        }
        case UPDATE_VALUTA: {
            return {
                ...state,
                valuta: action.payload,
            };
        }
        case UPDATE_CONTEXT: {
            return {
                ...state,
                epiEditContext: {
                    ...state.epiEditContext,
                    ...action.payload,
                },
            };
        }
        case UPDATE_ZINDEX: {
            return {
                ...state,
                epiEditContext: {
                    ...state.epiEditContext,
                    editZIndex: action.payload,
                },
            };
        }
        default:
            return state;
    }
}
